import { t } from 'i18next';
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from "react-helmet-async";
import { useNavigate } from 'react-router-dom';
import { LoaderContext } from '../../AuthContext/AuthContext';


const RefundPolicy = () => {
  const { selectedLanguageID } = useContext(LoaderContext);
  const [metaDesc, setMetaDesc] = useState("Read the Myomnamo refund policy for puja bookings, subscriptions, and spiritual services. Understand cancellation rules, eligibility, and refund timelines");
  const [metaTitle, setMetaTitle] = useState("Refund Policy | Online Puja & Spiritual Services | Myomnamo");

  const navigate = useNavigate()
  useEffect(() => {
    navigate('/refund-policy')
  }, [selectedLanguageID])
  return (
    <>
      <Helmet>
        <title>
          {metaTitle}
        </title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />
        <link rel="canonical" href="https://www.myomnamo.com/refund-policy" />
        <meta
          property="og:title"
          content={metaTitle}
        />
        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={metaTitle}
        />
        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>

      <div
        className="container mx-auto p-6 mt-5"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <h3 className="text-2xl font-bold mb-4">
          {t("Refund Policy for Myomnamo")}
        </h3>
        <p className="mb-4">
          {t(
            "Welcome to Myomnamo We are committed to providing you with the best spiritual services. Please read our refund policy carefully to understand your rights and obligations regarding purchases made through our website"
          )}{" "}
          (
          <a
            href="https://www.myomnamo.com"
            className="text-blue-500 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.myomnamo.com
          </a>
          ).
        </p>

        <h4>{t("1. Eligibility for Refunds")}</h4>
        <p>{t("Refunds may be issued under the following conditions:")}</p>
        <ul>
          <li>{t("The transaction was made in error.")}</li>
          <li>{t("The product/service purchased is unavailable or could not be delivered.")}</li>
          <li>{t("The service/product received is significantly different from its description.")}</li>
          <li>{t("Duplicate or unauthorized transactions.")}</li>
        </ul>

        <h4 className="mt-4">{t("2. Timeframe for Refund Requests")}</h4>
        <p>
          {t("You must submit a refund request within")}{" "}
          <strong>{t("3 days")}</strong>{" "}
          {t(
            "from the date of the transaction. After this period, refund requests may not be accepted."
          )}
        </p>

        <h4 className="mt-4">{t("3. How to Request a Refund")}</h4>
        <p>{t("To request a refund, please contact us at:")}</p>
        <ul>
          <li>
            📧 {t("Email:")} <a href="mailto:info@myomnamo.com">info@myomnamo.com</a>
          </li>
          <li>
            📞 {t("Phone:")} <a href="tel:+917738581133">+91 7738581133</a>
          </li>
        </ul>
        <p>📝 {t("Provide the following details:")}</p>
        <ul>
          <li>{t("Name")}</li>
          <li>{t("Registered Mobile Number")}</li>
          <li>{t("Transaction ID")}</li>
          <li>{t("Date of Transaction")}</li>
          <li>{t("Reason for Refund")}</li>
        </ul>

        <h4 className="mt-4">{t("4. Refund Process")}</h4>
        <p>
          {t("Once your request is received and verified, we will initiate a refund via")}{" "}
          <strong>{t("PhonePe")}</strong>.
        </p>
        <p>
          {t("Return/Exchange Period: Varies between")}{" "}
          <strong>{t("1 to 2 days")}</strong>
          {t(", depending on the merchant and product category.")}
        </p>
        <p>{t("If return/exchange is approved it will be returned/exchanged in 7-10 days")}</p>
        <p>{t("Refunds will be credited within")} <strong>{t("7-10 business days")}</strong>.</p>
        <p>{t("You will receive a confirmation once the refund has been issued.")}</p>

        <h4 className="mt-4">{t("5. Delivery Process Process")}</h4>
        <p>{t("Will deliver your product within 8-10 Day's.")}</p>

        <h4 className="mt-4">{t("6. Non-Refundable Situations")}</h4>
        <ul>
          <li>{t("Change of mind after a successful transaction.")}</li>
          <li>{t("Failure to read the product/service description.")}</li>
          <li>{t("Requests submitted beyond the eligible refund window.")}</li>
        </ul>

        <h4 className="mt-4">{t("7. Dispute Resolution")}</h4>
        <p>
          {t(
            "If you have any disputes regarding transactions or refunds, please reach out to us first. If unresolved, you may contact PhonePe customer support for further assistance."
          )}
        </p>

        <h4 className="mt-4">{t("8. Policy Updates")}</h4>
        <p>
          {t(
            "We may update this Refund Policy from time to time. Changes will be posted within the app or on our website with an updated “Effective Date.”"
          )}
        </p>
      </div>

    </>
  );
};

export default RefundPolicy